// src/components/Banner/Banner.js
import React from 'react';
// import { FiArrowRight } from 'react-icons/fi';
// import Button from '../shared/Button';
import styled from 'styled-components';
import { fadeIn } from '../shared/animations';
import { Link } from 'react-router-dom';


// Styled Components
const HeroContainer = styled.section`
  background: linear-gradient(135deg, #151c48 0%, #2a3a8f 100%);
  color: white;
  padding: 100px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('https://images.unsplash.com/photo-1556905055-8f358a7a47b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80') center/cover;
    opacity: 0.15;
    z-index: 0;
  }
      @media (max-width: 768px) {
    padding: 80px 20px;
  }
`;

const HeroTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.2;
  letter-spacing: -1px;
  animation: ${fadeIn} 0.8s ease-out;

  span {
    color: #5ab9d3;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.5rem;
  max-width: 800px;
  margin: 0 auto 40px;
  opacity: 0.9;
  animation: ${fadeIn} 0.8s ease-out 0.2s forwards;
  opacity: 0;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;


const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const SecondaryButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 16px 34px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  border: 2px solid #ffffff;
  color: #ffffff;
  background: transparent;
  text-decoration: none;
  margin: 0 10px 20px;
  transition: all 0.3s ease;
  animation: ${fadeIn} 0.8s ease-out 0.5s forwards;
  opacity: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.4);
    color: #ffffff;
  }
`;



const Banner = () => {
  return (
    <HeroContainer>
      <Container>
        <HeroTitle>
          <span>Realocação para Portugal sem complicações</span>
        </HeroTitle>
        <HeroSubtitle>
          Conectamos você aos melhores consultores e empresas de relocation em Portugal.
          Encontre a ajuda certa para sua mudança com facilidade e segurança.
        </HeroSubtitle>
        <div>
          {/* <Button href="#premium" primary>
            Conheça nosso serviço <FiArrowRight />
          </Button> */}
          <SecondaryButton to="/contact">
            Fale conosco agora
          </SecondaryButton>


        </div>
      </Container>
    </HeroContainer>
  );
};

export default Banner;